import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { BaseGlobalSegmentComponent } from '../../../common/_base-global-segment.component';
import { BrandInformationService } from '../../brand-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  providers: [BrandInformationService],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseSegmentComponent extends BaseGlobalSegmentComponent implements OnInit {
  constructor(
    protected router: Router,
    protected brandInformationService: BrandInformationService,
    protected informationPageService: InformationPageService,
    protected permissionsService: PermissionsService,
    protected ref: ChangeDetectorRef,
  ) {
    super(
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    if (!this.permissionsService.hasPermission(['admin', 'catalog-edit'])) {
      this.router.navigate(['/logout']);
    }
    super.ngOnInit();
  }

  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

   protected refreshSegmentData() {
    const segmentData = this.brandInformationService.getSegmentData(this.name);
    this.segmentData = _.orderBy(segmentData, ['sequence']);
  }

  protected refreshData(): Observable<any> {
    return this.brandInformationService.getData(this.name);
  }
}
